module.exports = __webpack_public_path__ + "img/img1.5583cda0.png";